// src/config/workspaceHeader.js
// A simple module-level mutable ref that bridges React context → axios interceptor.
// WorkspaceContext writes to this; axiosConfig reads from it.
let activeWorkspaceId = null;

export const setWorkspaceHeader = (id) => {
    activeWorkspaceId = id;
};
export const getWorkspaceHeader = () => activeWorkspaceId;
